import {
  Button,
  Drawer,
  Form,
  Space,
  Input,
  message,
  Row,
  Col,
  Select,
} from "antd";
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import fetchAllSegments from "../../../services/fetchAllSegments";
import updateARPPSCustomer from "../../../services/updateARPSCustomer";

const { Option } = Select;

export default function UpdatePanel({
  isVisible,
  selected,
  setVisible,
  refetch,
}: any) {


  const [form] = Form.useForm();
  const [segments, setSegments] = useState<any>([]);

  const customer_id = selected?._id;

  const handleFetchSegments = async () => {
    const response = await fetchAllSegments();
    setSegments(response?.payload);
  };

  const formatMobile = (mobile: any) => {
    let num = mobile ? mobile : "";
    let trim = num?.trim();
    let mob = trim?.slice(-9);
    return mob;
  };

  const startsWith = (str: any, word: any) => {
    return str.lastIndexOf(word, 0) === 0;
  };
  const onSubmit = async () => {
    const { mobile, mobile2, segment, isDeleted, isDisabled } =
      await form.getFieldsValue();
    let formated = null;
    let formated2 = null;
    if (mobile) {
      const trimmed = mobile.replace(/\s/g, "");
      if (trimmed.toString().length === 10) {
        let zero = startsWith(`${trimmed}`, "0");
        if (zero) {
          let num = trimmed.substring(1);
          formated = `+255${num}`;
        }
      } else {
        if (trimmed.toString().length < 9 || trimmed.toString().length > 9) {
          message.error("Please provide a valid number");
          return;
        }
        formated = `+255${trimmed}`;
      }
    }
    if (mobile2) {
      const trimmed = mobile2.replace(/\s/g, "");
      if (trimmed.toString().length === 10) {
        let zero = startsWith(`${trimmed}`, "0");
        if (zero) {
          let num = trimmed.substring(1);
          formated2 = `+255${num}`;
        }
      } else {
        if (trimmed.toString().length < 9 || trimmed.toString().length > 9) {
          message.error("Please provide a valid number");
          return;
        }
        formated2 = `+255${trimmed}`;
      }
    }
    const data = {
      mobile: formated,
      mobile2: formated2,
      segment,
      isDisabled,
      isDeleted,
    };

    const response = await updateARPPSCustomer(customer_id, data);
    if (response.success === false) {
      message.error("Something went wrong");
    } else {
      if (response.success) {
        message.success("Updated Successfully");
        refetch();
        form.resetFields();
        hideModal();
      } else {
        message.error(response.message);
      }
    }
  };

  const hideModal = () => {
    setVisible(false);
  };

  const segmentOptions = segments.map((segment: any, index: number) => (
    <Option value={segment?._id} key={index}>
      {segment?.name}
    </Option>
  ));

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
    handleFetchSegments();
  }, [selected]);

  return (
    <Drawer
      title={`Update Customer`}
      placement={"right"}
      width={600}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space className="flex justify-center items-center">
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="py-2 mb-4">
        <span className="font-bold">CUSTOMER : </span> {selected?.name}
      </div>
      <Form
        id="updateDetails"
        form={form}
        layout="vertical"
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mobile"
              label="Customer Mobile"
              initialValue={formatMobile(selected?.mobile)}
              rules={[
                {
                  required: false,
                  message: "Please enter mobile number 1",
                },
              ]}
            >
              <Input
                addonBefore="+255"
                style={{ width: "100%" }}
                placeholder="Mobile number 1"
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mobile2"
              label="Customer Mobile 2"
              initialValue={formatMobile(selected?.mobile2)}
              rules={[
                {
                  required: false,
                  message: "Please enter mobile number 2",
                },
              ]}
            >
              <Input
                addonBefore="+255"
                style={{ width: "100%" }}
                placeholder="Mobile number 2"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="segment"
              label="Customer Segment"
              initialValue={selected?.segment?._id}
              rules={[
                {
                  required: true,
                  message: "Please select segment",
                },
              ]}
            >
              <Select defaultValue={selected?.role} placeholder="Segment">
                {segmentOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="isDisabled"
              label="Suspend Access"
              initialValue={selected?.isDisabled}
              rules={[
                {
                  required: false,
                  message: "Please select one option",
                },
              ]}
            >
              <Select
                defaultValue={selected?.isDisabled}
                placeholder="Suspend Access"
              >
                <Option value={true}>Yes</Option>
                <Option value={false}>No</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="isDeleted"
              label="Disable Access"
              initialValue={selected?.isDeleted}
              rules={[
                {
                  required: false,
                  message: "Please select one option",
                },
              ]}
            >
              <Select
                defaultValue={selected?.isDeleted}
                placeholder="Disable Access"
              >
                <Option value={true}>Yes</Option>
                <Option value={false}>No</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button danger type="primary" htmlType="submit">
            Submit
          </Button>
          <Button danger htmlType="button" className="mx-2" onClick={clearForm}>
            Reset
          </Button>
          <Button danger htmlType="button" className="mx-2" onClick={hideModal}>
            Close
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}
